import React from 'react'
// import InlinePreloader from '../InlinePreloader'

const FormButton = ({buttonLabel, buttonAction, processing}) => {
  return (
    <button type='submit' disabled={processing} onClick={()=>{buttonAction()}} className='w-full p-4 rounded-[8px] bg-doiteasy-blue text-white text-sm transition duration-200 hover:bg-blue-700 font-[550] flex items-center justify-center'>{processing ? <div className='btn-loader' /> : buttonLabel}</button>
  )
}

export default FormButton